import classNames from 'classnames';
import { useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import './styles.scss';

interface FilterButtonProps {
  variant?: 'primary' | 'secondary';
  title: string;
  onClick: () => void;
}

const variantToColorMap = {
  primary: 'color-mainblue',
  secondary: 'color-gray2',
};

const FilterButton = ({ variant = 'secondary', title = '', onClick }: FilterButtonProps) => {
  const className = useMemo(() => variantToColorMap[variant], [variant]);

  return (
    <div onClick={onClick} className={classNames(className, 'advanced-filter-button')}>
      {localeStore.t(title)}
    </div>
  );
};

export default FilterButton;
